const formatKey = (text: string) => text.replaceAll(" ", "-").toLowerCase();

export default formatKey;
